import React from 'react';
import PptxGenJS from 'pptxgenjs';
import firstSlideLogo from '../assets/First Slide Logo 2.png'; 
import firstSlideShield from '../assets/First slide shield.png';

const ProductMarketSharePPTX = ({ savingsData, chequeData, creditCardData, homeLoanData, vehicleFinanceData }) => { 

  // Function to create a slide with product market share data
  const createSlide = (pptx, title, data) => {
    const slide = pptx.addSlide();
    const years = data.map(item => item.Year);
    const absaData = data.map(item => item.Absa);
    const capitecData = data.map(item => item.Capitec);
    const fnbData = data.map(item => item.FNB);
    const nedbankData = data.map(item => item.Nedbank);
    const standardBankData = data.map(item => item['Standard Bank']);
    const tymeBankData = data.map(item => item.TymeBank);

    let data_copy = [...data]
    data_copy.pop()
    
    let ranks = data_copy.map((item, index) => {       
          return item['Standard Bank Rank']    
    })     

    slide.addText(title, {
      x: 'center', y: 0.7, fontSize: 24, color: '#0039a6', bold: true, align: 'center', fontFace: 'Segoe UI'
    });   //Changed y to 0.7 from 0.8 to move it up. This value is measured from the top of the slide, in inches

    // Add ranks at the top of the slide
    ranks.forEach((rank, index) => {
      slide.addText(`${rank}`, {
        x: 0.95 + index * 0.87, // Adjusted spacing for each rank
        y: 1.1,
        fontSize: 12,
        color: '#0039a6',
        bold: false,
        fontFace: 'Segoe UI',
      });
    });

    slide.addChart(pptx.ChartType.line, [
      { name: 'Absa', labels: years, values: absaData, lineSize: 2, color: '#C8102E' },
      { name: 'Capitec', labels: years, values: capitecData, lineSize: 3, color: '#E75480' },
      { name: 'FNB', labels: years, values: fnbData, lineSize: 2, color: '#003876' },
      { name: 'Nedbank', labels: years, values: nedbankData, lineSize: 2, color: '#005941' },
      { name: 'Standard Bank', labels: years, values: standardBankData, lineSize: 2, color: '#0473EA' },
      { name: 'TymeBank', labels: years, values: tymeBankData, lineSize: 2, color: '#f4ca16' }
    ], {
      x: 0.5, y: 1, w: 9, h: 4,
      showLegend: true,
      legendPos: 'b',
      legendColor: '000000',
      legendFontSize: 12,
      title: 'Total',
      titleFontSize: 28,
      titleAlign: 'center',
      showValue: true,
      dataLabelFontFace: 'Verdana',
      dataLabelFontSize: 12,
      dataLabelColor: '#FFFFFF',
      dataLabelPosition: 'ctr',
      dataLabelPlacement: 't',
      majorGridline: false,
      valAxisHidden: true,
      catAxisHidden: false,
      lineDataSymbol: 'square',
      lineDataSymbolSize: 20,
      valGridLine: { style: "none" },
      chartColors: ['#C8102E', '#E75480', '#003876', '#005941', '#0473EA', '#f4ca16']
    });
  };

  const generatePowerPoint = () => {
    const pptx = new PptxGenJS();

    // Slide 1 - Title Slide
    const slide1 = pptx.addSlide();
    slide1.addShape(pptx.ShapeType.rect, {
      x: 0, y: 0, w: '100%', h: '100%',
      fill: { color: '#0039a6' }
    });
    slide1.addImage({ path: firstSlideLogo, x: 0.4, y: 0.3, w: 4, h: 1.2 });
    slide1.addText('PRODUCT MARKET SHARE', { x: 0.5, y: 2.5, fontSize: 35, color: '#FFFFFF' });
    slide1.addText('PERSONAL &', { x: 0.5, y: 3, fontSize: 35, color: '#ADD8E6' });
    slide1.addText('PRIVATE BANKING (PPB)', { x: 0.5, y: 3.5, fontSize: 35, color: '#ADD8E6' });
    slide1.addText('2017 - 2024 Results', { x: 0.5, y: 4.5, fontSize: 30, color: '#FFFFFF' });
    slide1.addImage({ path: firstSlideShield, x: 6.5, y: 0.7, w: 3, h: 4 });

    // Data Sets and Titles for Each Slide
    const datasets = [
      { title: 'Savings', data: savingsData },
      { title: 'Cheque', data: chequeData },
      { title: 'Credit Card', data: creditCardData },
      { title: 'Home Loan', data: homeLoanData },
      { title: 'Vehicle Finance', data: vehicleFinanceData }
    ];

    // Generate Slides for Each Data Set
    datasets.forEach(({ title, data }) => {
      if (data) {
        createSlide(pptx, title, data);
      }
    });

    pptx.writeFile('Product Market Share Presentation');
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '2vh auto', width: '50%' }}>
      <button onClick={generatePowerPoint}>Download PowerPoint</button>
    </div>
  );
};

export default ProductMarketSharePPTX;

